// Filter for unique array elements.
export default function filterParams( param, value ) {
	var url = window.location.search;
	var query = new URLSearchParams( url );

	if ( query.get( param ) ) {
		let queryString = query.get( param );

		if ( queryString.includes( ',' ) ) {
			let items = queryString.split( ',' );
			let filterItems = items.filter( function ( item ) {
				return item !== value;
			} );
			return filterItems.toString();
		}
	} else {
		return value;
	}
}
